import type { RequestInfo } from '@ember-data/request';
import { buildBaseURL, type QueryUrlOptions } from '@warp-drive/utilities';
import { SkipCache } from '@warp-drive/core-types/request';

/**
 * PATCH /people/:id/contribution-account — reorder the person's
 * contribution accounts. Body is the legacy JSON:API shape the server
 * expects (singular `person` type with snake_case attribute key).
 */
export function updateContributionAccountRequest(
  personId: string,
  accountIds: string[]
): RequestInfo {
  const opts: QueryUrlOptions = {
    identifier: { type: 'people' },
    op: 'query',
    resourcePath: 'people',
  };
  return {
    url: `${buildBaseURL(opts)}/${personId}/contribution-account`,
    method: 'PATCH',
    body: JSON.stringify({
      data: {
        type: 'person',
        id: personId,
        attributes: { account_order: accountIds },
      },
    }),
    cacheOptions: { [SkipCache]: true },
  };
}
